import React, {useState} from 'react';
import {IonAlert, IonIcon} from '@ionic/react';
import {warningSharp} from 'ionicons/icons';
import {useHistory} from 'react-router-dom';

import {CountyData} from "../../interfaces/CountyData";
import Panel from "../ui/Panel";
import RankedBars, {RankedBarRow} from "../ui/RankedBars";

interface GraphDataCardprops {
  content: any;
  crashList: CountyData[];
}

const CrashesCard: React.FC<GraphDataCardprops> = (props: GraphDataCardprops) => {
  const [modalOpen, setModalOpen] = useState(false);
  const history = useHistory();

  const openModal = () => {
    if (props.content.source != "N/A") setModalOpen(true);
  };
  const closeModal = () => setModalOpen(false);
  const handleOkay = () => {
    closeModal();
    history.push('/AppCenter/TranscoreAnalytics');
  };

  const total = Number(props.content.data);
  const rows: RankedBarRow[] = props.crashList.map(county => ({
    name: county.name,
    display: `${county.crashes} (${Math.floor((county.crashes / total) * 100)}%)`,
    percent: Math.floor((county.crashes / total) * 100),
  }));

  return (
    <>
      <Panel
        title="Crashes by county"
        subtitle="Share of crashes this week"
        accent="var(--domain-crashes)"
        icon={<IonIcon icon={warningSharp} />}
        onInfo={openModal}
        infoLabel="About crash counts"
        footer={`Updated ${props.content.updated}`}
      >
        <div className="dashboard__scroll">
          <RankedBars rows={rows} accent="var(--domain-crashes)" />
        </div>
      </Panel>

      <IonAlert
        isOpen={modalOpen}
        header={props.content.title}
        subHeader={"Source: " + props.content.source}
        message={props.content.description}
        buttons={[{text: "More Information", handler: handleOkay}]}
        onDidDismiss={closeModal}
        cssClass="bigger-alert"
      ></IonAlert>
    </>
  );
};
export default CrashesCard;
